import { GavelIcon } from 'lucide-react'
import { useMemo } from 'react'

import { Card, CardContent } from '@/components/card/card'

import { type ClientPortalEoirNextHearing } from '@/lib/queries/case-dashboard/types'
import { cn } from '@/lib/utils'

export interface NextHearingInfoCardProps {
  nextHearingData?: ClientPortalEoirNextHearing | null
}

export const NextHearingInfoCard = ({ nextHearingData }: NextHearingInfoCardProps) => {
  const { date, time, judge, type, medium, courtAddress } = nextHearingData ?? {}

  const dateTime = useMemo(() => {
    if (!date) {
      return '-'
    }
    if (!time) {
      return date
    }
    return `${date} at ${time}`
  }, [date, time])

  return (
    <Card>
      <CardContent className={cn('p-6')}>
        <p className={cn('flex items-center gap-x-2', 'text-base font-semibold text-foreground', 'mb-6')}>
          <GavelIcon size={24} />
          <span>Next Hearing</span>
        </p>

        {!nextHearingData && <NoData />}
        {nextHearingData && (
          <div className={cn('flex flex-col gap-y-3')}>
            <Description title="Date" description={dateTime} />
            <Description title="Judge" description={judge ?? '-'} />
            <Description title="Type" description={type ? `${type} Hearing` : '-'} />
            <Description title="Medium" description={medium ?? '-'} />
            <Description title="Court Address" description={courtAddress ?? '-'} />
          </div>
        )}
      </CardContent>
    </Card>
  )
}

const NoData = () => {
  return (
    <p className={cn('text-xs font-medium text-foreground', 'bg-elevated', 'px-5 py-4', 'rounded-[5px]')}>
      No upcoming hearing.
    </p>
  )
}

const Description = ({ title, description }: { title: string; description: string }) => {
  return (
    <div className={cn('flex items-baseline gap-3')}>
      <div className={cn('text-[12px] font-[400] leading-[18px] text-[#555]')}>{title}</div>
      <div className={cn('flex-1', 'text-[14px] font-[500] leading-[22px]', 'text-right')}>{description}</div>
    </div>
  )
}
